import { Skeleton } from "@aircall/tractor";

import { SkeletonLabelProps } from "./SkeletonLabel.decl";

export function SkeletonLabel({ h = 16, w = 200 }: SkeletonLabelProps) {
  return <Skeleton h={h} w={w} />;
}
